import React from 'react';

const SvgArrowDown3 = () => (
  <svg viewBox="0 0 20 20" width="1em" height="1em">
    <path d="M10 13.2L5 6.8h10l-5 6.4z" fill="currentColor" />
  </svg>
);

export default SvgArrowDown3;
